import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import QuoteModal from "@/components/QuoteModal";
import { scrollToId } from "@/lib/scroll";

export default function PageShell({ children, testId = "page" }) {
    const [quoteOpen, setQuoteOpen] = useState(false);
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) setTimeout(() => scrollToId(hash.slice(1)), 100);
        else window.scrollTo(0, 0);
    }, [pathname, hash]);

    return (
        <div className="App bg-background text-foreground" data-testid={testId}>
            <Header onQuote={() => setQuoteOpen(true)} />
            {typeof children === "function" ? children({ openQuote: () => setQuoteOpen(true) }) : children}
            <Footer />
            <QuoteModal open={quoteOpen} onClose={() => setQuoteOpen(false)} />
            <Toaster position="bottom-right" theme="light" />
        </div>
    );
}

export function PageIntro({ eyebrow, title, lead }) {
    return (
        <div className="mx-auto max-w-7xl px-5 pb-10 pt-14 md:px-8 md:pt-20">
            {eyebrow && <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">{eyebrow}</p>}
            <h1 className="mt-2 font-display text-4xl font-bold leading-tight text-primary sm:text-5xl" data-testid="page-title">{title}</h1>
            {lead && <p className="mt-4 max-w-3xl text-lg text-foreground/80">{lead}</p>}
        </div>
    );
}

export function Prose({ children }) {
    return <div className="mx-auto max-w-7xl px-5 pb-20 md:px-8 [&_h2]:mt-10 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-primary sm:[&_h2]:text-3xl [&_p]:mt-4 [&_p]:max-w-3xl [&_p]:text-lg [&_p]:text-foreground/80 [&_ul]:mt-4 [&_ul]:max-w-3xl [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-6 [&_ul]:text-lg [&_ul]:text-foreground/80 [&_a]:font-semibold [&_a]:text-primary [&_a]:underline-offset-2 hover:[&_a]:underline [&_strong]:text-foreground">{children}</div>;
}
